import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
//#region src/redux/build/reducers.ts
var reducers_exports = /* @__PURE__ */ __exportAll({ updateBuild: () => updateBuild });
var updateBuild = (state, { payload }) => {
	state.build = payload?.build;
};
//#endregion
export { reducers_exports, updateBuild };

//# sourceMappingURL=reducers.js.map